<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'user'}">
              <a>ユーザー一覧</a>
            </router-link>
            <li class="active">CSVファイルのインポート</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>CSVファイルのインポート</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <!-- PAGE CONTENT BEGINS -->
                <div class="alert alert-info">
                  ユーザーの編集をCSVファイルから行うことができます。<br>
                  アップロードするCSVファイルを選択し、「ファイルをインポート」してください。
                </div>
                <div>
                  <div class="fallback">
                    <p class="desc">自分のコンピューターからファイルを選択する ：</p>
                    <label for="file_csv" class="btn-upload">
                      CSVファイルを選択
                      <input type="file" id="file_csv" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.csv'>
                    </label>
                    <span class="filename">選択されていません</span>
                    <span class="error"></span>
                    <div id="result">
                    </div>
                    <button class="btn btn-info" type="button" href="#question" data-toggle="modal">
                      ファイルをインポート
                    </button>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">CSVファイルのインポート</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="message.length === 0">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <div v-else style="width:100%;padding:10px;border:1px solid #ccc;color:red;margin-top:10px">
              <div v-html="message"></div>
            </div>
            <span class="success-label" v-if="successItem>0">{{totalDataRow}}件中{{successItem}}件をインポートしました。</span>
            <div v-if="errorMessage.length>0">
              <span class="error-box-title">インポート失敗</span>
              <div class="error-box">
                <template v-for="item in errorMessage">
                  <p v-html="item" :key="item"></p>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success" @click="reset()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!-- プロフィールModal -->
    <div id="question" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div>
              作成したユーザーのメールアドレスへ通知メールを送信しますか？
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success" style="width:100px" data-dismiss="modal" @click="yesChoice()">送信する</button>
            <button class="btn btn-sm" style="width:100px" data-dismiss="modal" @click="noChoice()">送信しない</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      files: null,
      errorMessage: [],
      importData: [],
      loading: false,
      message: '',
      errorName: '',
      progress: 0,
      success: false,
      totalDataRow: 0,
      exeCount: 0,
      successItem: 0,
      percent: 0,
      isSendEmail: false
    }
  },
  // totalDataRowとはCSVファイルの中にある項目数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCount に１をプラスする。
  // 全部APIを実行が終わるとexeCount の値は０にリセットする。
  // exeCount<totalDataRowの時は次のAPI実行。
  // exeCount===totalDataRowの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        vm.editExe(vm.importData[newVal][0], vm.importData[newVal][1], vm.importData[newVal][2], vm.importData[newVal][3], vm.importData[newVal][4], vm.importData[newVal][5], vm.importData[newVal][6], vm.importData[newVal][7], vm.importData[newVal][8], vm.importData[newVal][9], vm.importData[newVal][10], vm.importData[newVal][11], vm.importData[newVal][12], vm.importData[newVal][13], vm.importData[newVal][14], (newVal + 2), vm.percent)
      } else if (newVal > 0 && newVal === vm.totalDataRow) {
        this.exeCount = 0
        this.success = true
        this.importData = []
      }
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    }
  },
  methods: {
    yesChoice () {
      this.isSendEmail = true
      $('#process').modal({
        backdrop: 'static'
      })
      this.importExe()
    },
    noChoice () {
      this.isSendEmail = false
      $('#process').modal({
        backdrop: 'static'
      })
      this.importExe()
    },
    reset () {
      this.exeCount = 0
      this.successItem = 0
      setTimeout(() => {
        this.success = false
      }, 200)
      location.reload()
    },
    convertStringToBoolean (text) {
      var str = text.trim().toLowerCase()
      switch (str) {
        case '1':
          return true
        case '0':
          return false
        default:
          return true
      }
    },
    convertStringToBooleanSMS (text) {
      var str = text.trim().toLowerCase()
      switch (str) {
        case '1':
          return true
        case '0':
          return false
        default:
          return false
      }
    },
    previewFiles () {
      this.files = this.$refs.myFiles.files[0]
      $('.filename').html(this.files.name)
    },
    editExe (userId, password, name, furigana, email, isMfaSms, phoneNumber, isAdmin, isPhoneAdmin, shareKeyBeValid, passCode, thumbnail, option1, option2, isValid, z, percent) {
      var vm = this
      var tmpIsSendEmail = false
      if (email !== null && email !== '') {
        tmpIsSendEmail = vm.isSendEmail
      } else {
        tmpIsSendEmail = false
      }
      phoneNumber = phoneNumber.trim()
      phoneNumber = phoneNumber.replace(/\u200B/g, '')
      var phone = phoneNumber.substring(1)
      console.log('phoneNumber' + phoneNumber)
      var checkMfaSms = vm.convertStringToBooleanSMS(isMfaSms)
      var Infor = []
      var phoneNumberEnd = ''
      if (checkMfaSms === true) {
        if (phoneNumber.match(/^[0][0-9]{10}$/)) {
          phoneNumberEnd = '+81' + phone
        }
        Infor = {
          userId: userId,
          name: name,
          furigana: furigana,
          email: email,
          isMfaSms: vm.convertStringToBooleanSMS(isMfaSms),
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBooleanSMS(isAdmin),
          isPhoneAdmin: vm.convertStringToBooleanSMS(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBooleanSMS(shareKeyBeValid),
          phoneNumber: phoneNumberEnd,
          passCode: passCode,
          option1: option1,
          option2: option2,
          isValid: vm.convertStringToBoolean(isValid)
        }
      } else {
        Infor = {
          userId: userId,
          name: name,
          furigana: furigana,
          email: email,
          isMfaSms: vm.convertStringToBooleanSMS(isMfaSms),
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBooleanSMS(isAdmin),
          isPhoneAdmin: vm.convertStringToBooleanSMS(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBooleanSMS(shareKeyBeValid),
          passCode: passCode,
          option1: option1,
          option2: option2,
          isValid: vm.convertStringToBoolean(isValid)
        }
      }
      console.log(Infor)
      this.$http.put(Config.USERS_LIST_API + '/' + encodeURIComponent(encodeURIComponent(userId)), Infor)
        .then(response => {
          vm.exeCount++
          vm.successItem++
          console.log(response)
          vm.progress += percent
        })
        .catch((error) => {
          var rowstatus = ''
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              vm.exeCount++
              vm.progress += percent
              break
            case 400:
              vm.exeCount++
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, z, rowstatus)
              vm.progress += percent
              console.log(error)
              break
            case 403:
              vm.exeCount++
              vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, z, rowstatus)
              vm.progress += percent
              console.log(error)
              break
            case 404:
              vm.addExe(userId, password, name, furigana, email, isMfaSms, phoneNumber, isAdmin, isPhoneAdmin, shareKeyBeValid, passCode, thumbnail, option1, option2, isValid, z, percent)
              break
            case 500:
              vm.exeCount++
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, z, rowstatus)
              vm.progress += percent
              console.log(error)
              break
            case 503:
              vm.exeCount++
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, z, rowstatus)
              vm.progress += percent
              console.log(error)
              break
            default:
              vm.exeCount++
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, z, rowstatus)
              vm.progress += percent
              console.log(error)
              break
          }
        })
    },
    addExe (userId, password, name, furigana, email, isMfaSms, phoneNumber, isAdmin, isPhoneAdmin, shareKeyBeValid, passCode, thumbnail, option1, option2, isValid, z, percent) {
      var vm = this
      var tmpIsSendEmail = false
      if (email !== null && email !== '') {
        tmpIsSendEmail = vm.isSendEmail
      } else {
        tmpIsSendEmail = false
      }
      phoneNumber = phoneNumber.trim()
      phoneNumber = phoneNumber.replace(/\u200B/g, '')
      var phone = phoneNumber.substring(1)
      var checkMfaSms = vm.convertStringToBooleanSMS(isMfaSms)
      var Infor = []
      var phoneNumberEnd = ''
      if (checkMfaSms === true) {
        if (phoneNumber.match(/^[0][0-9]{10}$/)) {
          phoneNumberEnd = '+81' + phone
        }
        Infor = {
          userId: userId,
          password: password,
          name: name,
          furigana: furigana,
          email: email,
          isMfaSms: vm.convertStringToBooleanSMS(isMfaSms),
          phoneNumber: phoneNumberEnd,
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBooleanSMS(isAdmin),
          isPhoneAdmin: vm.convertStringToBooleanSMS(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBooleanSMS(shareKeyBeValid),
          passCode: passCode,
          option1: option1,
          option2: option2,
          isValid: vm.convertStringToBoolean(isValid)
        }
      } else {
        Infor = {
          userId: userId,
          password: password,
          name: name,
          furigana: furigana,
          email: email,
          isMfaSms: vm.convertStringToBooleanSMS(isMfaSms),
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBoolean(isAdmin),
          isPhoneAdmin: vm.convertStringToBoolean(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBoolean(shareKeyBeValid),
          passCode: passCode,
          option1: option1,
          option2: option2,
          isValid: vm.convertStringToBoolean(isValid)
        }
      }
      console.log(Infor)
      this.$http.post(Config.USERS_LIST_API, Infor)
        .then(response => {
          vm.exeCount++
          vm.successItem++
          vm.progress += percent
          console.log(response)
        })
        .catch((error) => {
          vm.exeCount++
          var rowstatus = ''
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 403:
              vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 409:
              vm.errorName = '入力されたユーザーIDは既に使用されています。他のユーザーIDを入力してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
          }
          this.$set(this.errorMessage, z, rowstatus)
          vm.progress += percent
          console.log(error)
        })
    },
    importExe () {
      var vm = this
      if (this.files !== null) {
        this.progress = 0
        this.errorMessage = []
        var reader = new FileReader()
        reader.onload = function () {
          var lineArr = reader.result.split('\n')
          var itemArr = []
          for (var i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split(',')
          }
          if (itemArr.length > 1) {
            vm.importData = []
            for (var k = 1; k < itemArr.length; k++) {
              if (itemArr[k].length === 17 && itemArr[k][0].length > 0) {
                vm.importData.push(itemArr[k])
              }
            }
            console.log(vm.importData)
            if (vm.importData.length > 0) {
              vm.totalDataRow = vm.importData.length
              vm.message = ''
              vm.percent = (100 / (vm.totalDataRow))
              vm.editExe(vm.importData[0][0], vm.importData[0][1], vm.importData[0][2], vm.importData[0][3], vm.importData[0][4], vm.importData[0][5], vm.importData[0][6], vm.importData[0][7], vm.importData[0][8], vm.importData[0][9], vm.importData[0][10], vm.importData[0][11], vm.importData[0][12], vm.importData[0][13], vm.importData[0][14], 2, vm.percent)
            } else {
              vm.success = true
              vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
            }
          } else {
            vm.success = true
            vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
          }
        }
        reader.onerror = function () {
          vm.success = true
          vm.message = '選択されているファイルの読み込みに失敗しました。<br>ブラウザの更新、もしくは別ファイルを選択してから <br> 再度アップロードしたいファイルを選択してください。'
        }
        reader.readAsText(this.files, 'Shift_JIS')
      } else {
        vm.success = true
        vm.message = 'CSVのファイルを選択してください。'
      }
    }
  }
}
</script>
<style type="text/css">
#result p {
  margin-bottom: 0px
}
#result span {
  display: inline-block;
  padding: 5px;
}
#result span.error {
  color: red
}
#result span.success {
  color: #87B87F;
}
#result p.block {
  display: block;
  margin-bottom: 1px;
}
.btn-upload{
  color: white;
  background-color: #000;
  padding: 6px 15px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-block;
  margin: 0px 15px
}
.desc{
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}
.filename{
  display: inline-block;
}
.hide{
  display: none;
}
.error{
  display: block;
  color: #FF4040
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserImport.vue